import {
  HistorialAvisosContextProvider,
  useHistorialAvisos,
} from "./HistorialAvisosContext";
import { getHistorialAvisos } from "../../services/Api/historial-avisos";
import { MESSAGES } from "../../utils/messagesUtils";
import { toast } from "react-toastify";
import { usePagination } from "../../hooks/usePagination";
import { UserContext } from "../../services/user";
import alertConfiguration from "../../utils/alertsUtils";
import { esAvisoDeProceso } from "../../utils/avisosProcesoUtils";
import HistorialAvisosFilter from "./fragments/HistorialAvisosFilter";
import HistorialAvisosTable from "./fragments/HistorialAvisosTable";
import LoadingScreen from "../../fragments/LoadingScreen";
import NoDataMessage from "../../fragments/NoDataMessage";
import React, { useContext, useEffect, useState } from "react";
import SubHeaderHistorialAvisos from "./fragments/SubHeaderHistorialAvisos";
import TablePagination from "../../fragments/TablePagination";
import withUserAccesability from "../../hoc/withUserAccesability";

const itemsPerPage = 20;

const HistorialAvisosHome = ({ isUserAllowed }) => {
  return (
    <HistorialAvisosContextProvider>
      <HistorialAvisosHomeComponents isUserAllowed={isUserAllowed} />
    </HistorialAvisosContextProvider>
  );
};

const HistorialAvisosHomeComponents = ({ isUserAllowed }) => {
  const { avisosFiltro, setAvisos, setAvisosFiltro } = useHistorialAvisos();
  const { user, activeRole } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const { next, prev, jump, currentData, currentPage, maxPage } = usePagination(
    avisosFiltro,
    itemsPerPage
  );

  useEffect(() => {
    if (activeRole !== "") {
      getAvisos();
    }
  }, [activeRole]);

  useEffect(() => {
    const interval = setInterval(() => {
      getAvisos();
    }, 180000);

    return () => clearInterval(interval);
  }, []);

  const getAvisos = async () => {
    try {
      const avisosResp = await getHistorialAvisos(user._id);
      //console.log("Avisos recibidos:", avisosResp);
      const avisosFiltrados = avisosResp.filter(
        (aviso) => !esAvisoDeProceso(aviso?.aviso)
      );
      const sortedAvisos = avisosFiltrados.sort(
        (a, b) => new Date(b.fechaRecibido) - new Date(a.fechaRecibido)
      );
      setAvisos(sortedAvisos);
      setAvisosFiltro(sortedAvisos);
    } catch (error) {
      console.error(error);
      toast.error(error.message, alertConfiguration);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div className="bg-backgroundColor pb-4 h-[calc(100vh-4.25rem)] flex flex-col">
          <SubHeaderHistorialAvisos />
          <div className="relative flex-1 flex flex-col px-4 sm:px-8 overflow-hidden">
            <HistorialAvisosFilter
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
            />
            <div className="flex-1 overflow-auto">
              {avisosFiltro?.length !== 0 && (
                <HistorialAvisosTable
                  getAvisos={getAvisos}
                  currentData={currentData()}
                />
              )}
              {avisosFiltro?.length === 0 && (
                <NoDataMessage message={MESSAGES.MESSAGES_HISTORIAL_AVISOS} />
              )}
            </div>
            {avisosFiltro?.length !== 0 && (
              <div className="flex-shrink-0">
                <TablePagination
                  next={next}
                  prev={prev}
                  jump={jump}
                  data={currentData()}
                  currentPage={currentPage}
                  maxPage={maxPage}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default withUserAccesability(HistorialAvisosHome);
